import React from "react";
import "./MetaLiftCreate.scss";
import { Form } from "react-bootstrap";

interface MetaLiftFormFieldProps {
  title: string;
  placeholder: string;
  helperText?: string;
  value?: string;
  onChange?: (value: string) => void;
}

const MetaLiftFormField: React.FC<MetaLiftFormFieldProps> = ({
  title,
  placeholder,
  helperText,
  value,
  onChange,
}) => (
  <div className="metaLiftWidgetBodyTextForm">
    <div className="metaLiftWidgetBodyTextFormTitle">{title}</div>
    <Form.Group className="metaLiftWidgetBodyFormGroup">
      <Form.Control
        type="text"
        as="textarea"
        rows={1}
        placeholder={placeholder}
        value={value}
        onChange={e => onChange?.(e.target.value)}
      />
      {helperText && (
        <Form.Text className="metaLiftWidgetBodyFormHelperText">{helperText}</Form.Text>
      )}
    </Form.Group>
  </div>
);

export default MetaLiftFormField;
